import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackageDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 3.86667C1 2.83574 1.73127 2 2.63333 2H6.1217C6.39413 2 6.65477 2.11115 6.84336 2.30775L8.46667 4H13C14.1046 4 15 4.89543 15 6V12.1333C15 13.1643 14.2687 14 13.3667 14H2.63333C1.73127 14 1 13.1643 1 12.1333V3.86667ZM6 10C6.55228 10 7 9.55228 7 9C7 8.44772 6.55228 8 6 8C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10Z",
		fill: "#43454A"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.04022 5L6.1217 3H2.63333C2.40481 3 2 3.25841 2 3.86667V12.1333C2 12.7416 2.40481 13 2.63333 13H13.3667C13.5952 13 14 12.7416 14 12.1333V6C14 5.44771 13.5523 5 13 5H8.04022ZM8.46667 4L6.84336 2.30775C6.65477 2.11115 6.39413 2 6.1217 2H2.63333C1.73127 2 1 2.83574 1 3.86667V12.1333C1 13.1643 1.73127 14 2.63333 14H13.3667C14.2687 14 15 13.1643 15 12.1333V6C15 4.89543 14.1046 4 13 4H8.46667ZM4 9C4 7.89543 4.89543 7 6 7C7.10457 7 8 7.89543 8 9C8 10.1046 7.10457 11 6 11C4.89543 11 4 10.1046 4 9ZM7 9C7 9.55228 6.55228 10 6 10C5.44772 10 5 9.55228 5 9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9Z",
		fill: "#CED0D6"
	})]
});
export default SvgPackageDark;
